'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  const links = [
    { label: t('footer.services'), href: '#services' },
    { label: t('footer.contact'), href: '#contact' },
  ];

  return (
    <footer className="border-t border-white/5 py-8 sm:py-10 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
        {/* Logo + links */}
        <div className="flex flex-col md:flex-row items-center gap-4 sm:gap-6 md:gap-10">
          <div className="flex items-center gap-2">
            <span className="text-monitor/40 text-xs font-bold uppercase tracking-widest">
              Nexavi
            </span>
          </div>
          <nav className="flex items-center gap-4 sm:gap-6">
            {links?.map((l, i) => (
              <React.Fragment key={l?.label}>
                {i > 0 && <span className="text-monitor/20 text-xs">·</span>}
                <a
                  href={l?.href}
                  className="text-monitor/40 text-xs sm:text-sm font-medium hover:text-monitor transition-colors duration-200"
                >
                  {l?.label}
                </a>
              </React.Fragment>
            ))}
          </nav>
        </div>

        {/* Copyright */}
        <span className="text-monitor/25 text-xs">{t('footer.copyright')}</span>
      </div>
    </footer>
  );
}